export const PACKAGING_TYPES = [
  { key: "QUANTITY", value: "Adet", shortCode: "Adet" },
  { key: "BOTTLE", value: "Şişe", shortCode: "Şişe" },
  { key: "METAL_PACKAGE", value: "Teneke", shortCode: "Teneke" },
  { key: "NYLON_PACKAGE", value: "Naylon Poşet", shortCode: "Naylon Poşet" },
  { key: "VACUUM_PACKAGE", value: "Vakumlu Paket", shortCode: "Vakumlu Paket" },
  { key: "PLASTIC_PACKAGE", value: "Plastik Kutu", shortCode: "Plastik Kutu" },
  { key: "WOODEN_PACKAGE", value: "Ahşap Kutu", shortCode: "Ahşap Kutu" },
  { key: "FREE_UNIT", value: "Serbest Miktar", shortCode: "Serbest Miktar" },
  { key: "BUCKET", value: "Kova", shortCode: "Kova" },
  { key: "OTHER", value: "Diğer", shortCode: "Diğer" }
];

export const UNIT_TYPES = [
    {key:"GRAM",value:"Gram", shortCode:"Gr"},
    {key:"KILOGRAM",value:"Kilogram", shortCode:"Kg"},
    {key:"TONS",value:"Ton", shortCode:"Ton"},
    {key:"QUANTITY",value:"Adet", shortCode:"Adet"},
    {key:"LITERS",value:"Litre", shortCode:"Lt"},
    {key:"MILLILITERS",value:"Mililitre", shortCode:"Ml"},
    {key:"Tümü", value:"Tümü", shortCode:"Tümü"}
];
   export const IMPORT_OPTIONS = [
     { value: "PRODUCTION_INBOUND", label: "Üretimden Mal Girişi" },
     { value: "RETURN_INBOUND", label: "İade Girişi" },
     { value: "CONSIGNMENT_INBOUND", label: "Emanet Girişi" },
     { value: "TRANSFER_INBOUND", label: "Depo Transfer Girişi" },
     { value: "PURCHASE_INBOUND", label: "Satın Alma Girişi"},
   ];

   export const EXPORT_OPTIONS = [
     { value: "SHIPMENT_OUTBOUND", label: "Sevkiyat Çıkışı" },
     { value: "BRANCH_OUTBOUND", label: "Şube Çıkışı" },
     { value: "SALES_REP_OUTBOUND", label: "Plasiyer Çıkışı" },
     { value: "INDIVIDUAL_OUTBOUND", label: "Bireysel Çıkış" },
     { value: "REWORK_OUTBOUND", label: "Rework Çıkışı" },
     { value: "PACKAGING_OUTBOUND", label: "Paketleme Çıkışı" },
     { value: "FACTORY_SALES_POINT_OUTBOUND", label: "Fabrika Satış Noktası Çıkışı" },
     { value: "TRANSFER_OUTBOUND", label: "Depo Transfer Çıkışı" },
   ];


export const WAREHOUSES = [
    {key:"DEPO1",value:"Depo-1", shortCode:"Depo-1"},
    {key:"DEPO2",value:"Depo-2", shortCode:"Depo-2"},
    {key:"DEPO3",value:"Depo-3", shortCode:"Depo-3"},
    {key:"DEPO4",value:"Depo-4", shortCode:"Depo-4"}
];

export const WAREHOUSE_STOCK_TYPES = [
    { key: "FOODS", value: "GIDA", shortCode: "GIDA" },
    { key: "SUPPLIES", value: "SARF", shortCode: "SARF" },
];

export function resolveEnum(key:any) {
        let all = new Array();
        all = all.concat(PACKAGING_TYPES);
        all = all.concat(UNIT_TYPES);
        all = all.concat(WAREHOUSES);
        all = all.concat(WAREHOUSE_STOCK_TYPES);
    
        let result = "";
        all.forEach((item) => {
            if (key == item.key) {
                result = item.shortCode;
                return;
            }
        });
        return result;
}

export const OZISIK_WAREHOUSE_LOCATION = {
    latitude:  39.6466909,
    longitude: 27.9390838
};

